import Firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/auth';
import { CT_FIREBASE_CONFIG } from '@/config';

const classtingApp = Firebase.initializeApp(CT_FIREBASE_CONFIG, 'classting');

export const ctFirebaseAuth = classtingApp.auth();
export const firestore = classtingApp.firestore();
const settings = { timestampsInSnapshots: true };
firestore.settings(settings);
